module.exports = __webpack_public_path__ + "static/media/luggage.7eff6ae1.svg";